// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter } from '../_abstract/adapter';
import { ModuleDriver } from '../_contracts';
import { getModuleBase } from '../_helpers/adapter';
export class AnchorAdapter extends AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `AnchorModule` to the `AnchorToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        this.validate(object, {
            content: {
                presence: true
            },
            'content.text': {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        const { text, slug } = object.content;
        return {
            content: text,
            meta: { slug },
            raw: `#ANCHOR[ ${text} ]`,
            type: TokenType.Anchor
        };
    }
    /**
     * Adapts (translates/maps) the passed-in `AnchorToken` to the `AnchorModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof token.meta === 'undefined') {
            throw new Error(`AnchorAdapter.tokenToObject(): [token.meta] property is missing!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        const slug = token.meta.slug;
        if (typeof slug !== 'string') {
            throw new Error(`AnchorAdapter.tokenToObject(): [token.meta.slug] property should be a [string], but got [${typeof slug}]!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        return {
            ...getModuleBase(),
            content: { text: token.content, slug },
            driver: ModuleDriver.Anchor
        };
    }
}
